import { TaskSystemContextProvider, useTaskSystemContext } from "../contexts";
import { TaskView } from "../enums";
import { TaskBoard } from "../TaskBoard";
import { TaskHeader } from "./TaskHeader";
import { TaskMenu } from "./TaskMenu";
import { Divider, styled } from "@monolith-forensics/monolith-ui";

const TaskSystemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  flex: 1 1 auto;
`;

const TaskSystemViews = () => {
  const { taskView } = useTaskSystemContext();

  switch (taskView) {
    case TaskView.KANBAN:
      return <TaskBoard />;
    case TaskView.LIST:
      return <div>Task List</div>;
    case TaskView.TABLE:
      return <div>Task Table</div>;
    case TaskView.TIME:
      return <div>Task Time Entries</div>;
    default:
      return <TaskBoard />;
  }
};

export const TaskSystem = () => {
  return (
    <TaskSystemContextProvider>
      <TaskSystemContainer>
        <TaskHeader />
        <Divider style={{ margin: 0, opacity: 0.5 }} />
        <TaskMenu />
        <TaskSystemViews />
      </TaskSystemContainer>
    </TaskSystemContextProvider>
  );
};
